import { mountVueComponent } from '@/lib/mount-vue-component';
export default () => {
  import('@/modules/payment-methods/components/PaymentMethodForm.vue').then(PaymentMethodForm => {
    mountVueComponent('payment-method-form', PaymentMethodForm);
  });
};
